import {IObjectData, ISystemRole} from "../../index";

export namespace nsGroup {
    export function isRolePartOfGroup(role: ISystemRole, groupId: IObjectData['id']): boolean {
        const isMemberOfGroups = (role?.memberofgroups ?? '').split(',').map(Number).includes(groupId)
        const isMemberOfGroup = (role?.memberofgroup ?? null) == groupId
        return isMemberOfGroups || isMemberOfGroup
    }
}